<template>
  <div class="hello">
    <div class="center" v-if="loading">
 <i class="fa fa-spin fa-spinner fa-5x"></i>
    </div>
    <div v-else>
      done
    </div>
    <div>
       <GmapMap  id="map" 
  :center="center"
  :zoom="13"
  map-type-id="terrain"
  style="width:100%; height:800px"
>
  <GmapMarker
    :key="index"
    v-for="(m, index) in markers"
    :position="m.position"
    :clickable="true"
    :draggable="true"
    :icon="getIcon(m.status)"
    @click="center=m.position" 
  />
   <gmap-info-window 
            @closeclick="window_open=false" 
            :opened="window_open" 
            :position="infowindow"
        >
            Hello world!
        </gmap-info-window>   
</GmapMap>
    </div>
  </div>
</template>

<script>
import { services } from '../../src/vuex/api'
import { mapGetters } from 'vuex'
import { getIcon } from '../../src/lib/functions'
export default {
  name: 'Users',
  mounted: function () {
    // this.latval = this.currentUser.location.coordinates[1]
    // alert(this.latval)
    // this.lngval = this.currentUser.location.coordinates[0]
    this.center = {lat: this.currentUser.location.coordinates[1] , lng: this.currentUser.location.coordinates[0]}
    this.getLocations()
  },
  data () {
    return {
       center: {},
            markers: [],
            getMap:this.$root.mapping,
            description:'',
            latval: 23,
            lngval:90,
            latLng: {},
            place:null,
        loading:false,
        error:'',
        success:'',
        getIcon
      }
  },
  methods: {
     getLocations(){
       var self = this
      self.loading = true
     services.patients.getLocationReport({} ) //  .getPatientInfo()
    .then(function (response) {
      let chartData = response.data
      var datas = []
      chartData.forEach(element => {
        if (element.location !== undefined){
          var marker = {position: {lat: element.location.coordinates[1], lng: element.location.coordinates[0]},status:element.status}
        } else {
          
        }
        datas.push(marker)
       })
       console.log(datas)
        self.markers = datas
        self.loading = false
    })
    .catch(function (error) {
      console.log(error)
      self.loading = false
    })
    },
    clickBtn () {
      this.loading = !this.loading
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
    }
  },
   computed: {
    ...mapGetters([
      'currentUser'
    ])
    
  },
  created:function(){
    this.center = {lat: this.currentUser.location.coordinates[1] , lng: this.currentUser.location.coordinates[0]}
    // alert(this.currentUser.location.coordinates[1] + ' ----- ' + this.currentUser.location.coordinates[0])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Report-Location.vue?33818280